import React, { useEffect, useState } from "react";
import "./Conclusion.css";
import { BlogById } from "../../../../utils/apis/blog/Blog";

const Conclusion = ({ blogId }) => {

  const [conclusion, setConclusion] = useState({});

  const getConclusion = async () => {
    const res = await BlogById(blogId);

    if (res?.success) {
      setConclusion(res?.data || {});
    }
  };

  useEffect(() => {
    if (blogId) {
      getConclusion();
    }
  }, [blogId]);

  return (
    <section className="Conclusion">
      <div className="Conclusion_banner_holder">

        <img
          src="/assets/images/blogs/right_quote.png"
          className="quote_img"
          alt="quote-img"
        />

        <h5 className="Conclusion_title">Conclusion</h5>

        <p className="Conclusion_text">
          {conclusion?.conclusion}
        </p>

        <img
          src="/assets/images/blogs/left_quote.png"
          className="right_quote_img"
          alt="quote-img"
        />

      </div>
    </section>
  );
};

export default Conclusion;